import { css } from '@emotion/react';
import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons/faSpinnerThird';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import {
  type FC, type ReactNode,
} from 'react';
import { ButtonComponent } from '~/_shared/baseComponents/buttons/button/button.component';
import { spinAnimationStyle } from '~/_shared/baseComponents/cssAnimations/spin.animation';
import { TooltipComponent } from '~/_shared/baseComponents/tooltip/tooltip.component';
import { ModalComponent } from '../../../_shared/components/modal/modal.component';
import { OverlayLoaderComponent } from '../../../_shared/components/overlay/overlayLoader.component';
import { useTranslation } from '../../../_shared/utils/hooks';

type BoundarySettingsModalProps = Readonly<{
  caption: string;
  isLoading: boolean;
  isFormValidating: boolean;
  isOpen: boolean;
  submitTooltipContent: ReactNode;
  children?: React.ReactNode;
  isSubmitDisabled: boolean;
  onClose: () => void;
  onSubmitClick: () => void;
}>;

const modalContentStyle = css({
  padding: 0,
});

const spinningIconStyle = css({
  '& > svg': spinAnimationStyle,
});

export const BoundarySettingsModalComponent: FC<BoundarySettingsModalProps> = ({
  caption,
  children,
  isFormValidating,
  isLoading,
  isOpen,
  isSubmitDisabled,
  onClose,
  onSubmitClick,
  submitTooltipContent,
}) => {
  const [t] = useTranslation();

  return (
    <ModalComponent
      isOpen={isOpen}
      onClose={onClose}
      caption={caption}
      contentStyle={modalContentStyle}
      confirmButton={(
        <TooltipComponent tooltipContent={submitTooltipContent}>
          <ButtonComponent
            prefixIconStyle={isFormValidating ? spinningIconStyle : undefined}
            prefixIcon={isFormValidating ? faSpinnerThird : faCheck}
            text={t('Save')}
            onClick={onSubmitClick}
            isDisabled={isSubmitDisabled || isFormValidating}
          />
        </TooltipComponent>
      )}
      leftFooterContent={(
        <>
          {isLoading && (
            <OverlayLoaderComponent />
          )}
        </>
      )}
    >
      {children}
    </ModalComponent>
  );
};
